import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [  
  {
    path: '*',
    component: () => import('../views/page-error')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/index-apps')
    //component: () => import('../views/auth-login')
    
  },
  {
    path: '/index-personal',
    name: 'home',
    component: () => import('../views/index-personal')
  },
  {
    path: '/subscription',
    name: 'home',
    //component: () => import('../views/subscription')
    component: () => import('../views/index-apps')

  },
  {
    path: '/revpay-callback-success',
    name: 'revpay-callback-success',
    component: () => import('../views/revpay-callback-success')
  },
  {
    path: '/revpay-callback-fail',
    name: 'revpay-callback-fail',
    component: () => import('../views/revpay-callback-fail')
  },
  {
    path: '/my-account',
    name: 'home',
    //component: () => import('../views/my-account')
    component: () => import('../views/index-apps')

  },
  {
    path: '/auth-login',
    name: 'home',
    //component: () => import('../views/auth-login')
    component: () => import('../views/index-apps')

  },
  {
    path: '/auth-signup',
    name: 'home',
    //component: () => import('../views/auth-signup')
    component: () => import('../views/index-apps')

  },
  {
    path: '/auth-re-password',
    name: 'home',
    component: () => import('../views/auth-re-password')
  },
  {
    path: '/page-privacy',
    name: 'home',
    component: () => import('../views/page-privacy')
  },
  {
    path: '/page-comingsoon',
    name: 'comingsoon',
    component: () => import('../views/page-comingsoon')
  },
  {
    path: '/page-comingsoon2',
    name: 'comingsoon2',
    component: () => import('../views/page-comingsoon2')
  },
  {
    path: '/page-maintenance',
    name: 'maintenance',
    component: () => import('../views/page-maintenance')
  },
  {
    path: '/page-error',
    name: 'error',
    component: () => import('../views/page-error')
  },
  {
    path: '/page-thankyou',
    name: 'thankyou',
    component: () => import('../views/page-thankyou')
  },
  {
    path: '/page-contact-detail',
    name: 'contact-detail',
    component: () => import('../views/page-contact-detail')
  },
  {
    path: '/page-contact-one',
    name: 'contact-one',
    component: () => import('../views/page-contact-one')
  },
  {
    path: '/page-contact-two',
    name: 'contact-two',
    component: () => import('../views/page-contact-two')
  },
  {
    path: '/page-contact-three',
    name: 'contact-three',
    component: () => import('../views/page-contact-three')
  },
  {
    path: '/documentation',
    name: 'documentation',
    component: () => import('../views/documentation')
  },
  {
    path: '/changelog',
    name: 'changelog',
    component: () => import('../views/changelog')
  },
  {
    path: '/widget',
    name: 'widget',
    component: () => import('../views/widget')
  },
  {
    path: '/components',
    name: 'components',
    component: () => import('../views/components')
  },
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
    

  next()
});

export default router
